/**
 * Demo-mode knobs — the single place to tune or break the demo.
 *
 * Everything here is read by BOTH demo services (tabular and omics), so a
 * change applies to the whole app rather than to one pipeline. None of it is
 * read in real mode, with one exception noted below.
 *
 * These used to be `private readonly` fields buried in demo.service.ts, which
 * meant opening a 600-line file to slow the demo down.
 */

// ── Timing ────────────────────────────────────────────────────

/** Latency added to every faked response, in ms. Raise it to see spinners. */
export const DEMO_DELAY = 700;

/** Multiplies every SSE stream interval. 1 = fast demo, 3 = 3x slower. */
export const SSE_MULT = 1;

/** Delay before a file preview resolves, in ms. Separate from DEMO_DELAY
 *  because previews are the one place a visible wait is wanted. */
export const PREVIEW_LOAD_DELAY = 1200;

/** Multiplies the loading modal's slide interval (15 s). **Read in demo mode
 *  only** — aha-modal guards it on environment.demoMode, so a real run always
 *  uses the plain 15 s. */
export const DEMO_SLIDE_MULT = 1;

// ── Failure simulation ────────────────────────────────────────

/** Make every call fail its FIRST attempt, then succeed. Exercises each
 *  page's error state and its "Try again" without getting stuck. Resets on
 *  navigation, so the first call of every page fails. */
export const SIMULATE_ALL_FAILURES = false;

// ── Forced states (tabular) ───────────────────────────────────

/** Report every variable as not mapped, to exercise the guard that blocks
 *  Next on the strategy page. */
export const FORCE_ALL_NOT_MAPPED = false;

/** Report every variable as already reviewed: badge everywhere, and an empty
 *  un-reviewed queue. */
export const FORCE_ALL_REVIEWED = false;
